import { transport } from 'config/transport';

export function callApiUpdateAbsences(body) {
    return transport.put(`/mamnon/absences`, body);
}
